import { Button, ConfigProvider, Form, Grid, Input, Modal, Segmented, Select } from "antd";
import styles from "./App.module.scss";

import { useEffect, useRef, useState } from "react";
import {
  ArrowRight,
  Award,
  CreditCard2Front,
  Instagram,
  Lightning,
  ShieldCheck,
  Telegram,
  Tiktok,
  Truck,
  XCircle,
} from "react-bootstrap-icons";

import P4D from "./assets/sticks/P4-D.webp";
import P5D from "./assets/sticks/P5-D.webp";

import G1D from "./assets/sticks/G1-D.webp";
import G2D from "./assets/sticks/G2-D.webp";

import P7D from "./assets/sticks/P7-D.webp";
import P6D from "./assets/sticks/P6-D.webp";

import P1D from "./assets/sticks/P1-D.webp";

const PRIMARY = "#2fe6d5";
const PRIMARY_DARK = "#0b9385";
const INK = "#04211d";

const sticks = [
  {
    title: "Взрослые",
    price: "от 430 BYN",
    grab: [
      {
        value: "left",
        label: "Левый",
      },
      {
        value: "right",
        label: "Правый",
      },
    ],
    pics: [P4D, P5D],
    options: [
      {
        model: "SK CASTOR S001 (SST-350 грамм)",
        size: "167cm-177cm",
        price: "545 BYN",
        flex: [65, 75, 80, 85, 95],
      },
      {
        model: "SK CASTOR S001 (SST-380 грамм)",
        size: "167-180cm",
        price: "465 BYN",
        flex: [65, 75, 80, 85, 95],
      },
      {
        model: "SK CASTOR S001 (SST-410 грамм)",
        size: "169-175cm",
        price: "415 BYN",
        flex: [65, 75, 80, 85, 95],
      },
    ],
  },
  {
    title: "Детские",
    price: "от 350 BYN",
    grab: [
      {
        value: "left",
        label: "Левый",
      },
      {
        value: "right",
        label: "Правый",
      },
    ],
    options: [
      {
        model: "SK CASTOR J001 (JST-235 грамм)",
        size: "120cm-149cm",
        price: "350 BYN",
        flex: [20, 30, 40, 50],
      },
      {
        model: "SK CASTOR J003 (JST-270 грамм)",
        size: "132-149cm",
        price: "300 BYN",
        flex: [20, 30, 40, 50],
      },
      {
        model: "SK CASTOR J007 (JST-300 грамм)",
        size: "120-149cm",
        price: "280 BYN",
        flex: [20, 30, 40, 50],
      },
      {
        model: "SK CASTOR Y001 (YST-230 грамм)",
        size: "106.6-127cm",
        price: "265 BYN",
        flex: [20, 30, 40, 50],
      },
      {
        model: "SK CASTOR Y001 (YST-300 грамм)",
        size: "106.6-134cm",
        price: "240 BYN",
        flex: [20, 30, 40, 50],
      },
    ],
    pics: [P7D, P6D],
  },
  {
    title: "Юниорские",
    price: "от 320 BYN",
    grab: [
      {
        value: "left",
        label: "Левый",
      },
      {
        value: "right",
        label: "Правый",
      },
    ],
    options: [
      {
        model: "SK CASTOR I001 (IST-350 грамм)",
        size: "158cm-162cm",
        price: "505 BYN",
        flex: [50, 55, 60, 65],
      },
    ],
    pics: [P1D, P5D],
  },
  {
    title: "Вратарские",
    price: "от 500 BYN",
    grab: [
      {
        value: "left",
        label: "Левый",
      },
      {
        value: "right",
        label: "Правый",
      },
    ],
    options: [
      {
        model: "SK CASTOR 001 (GST-100)",
        size: "P31-B (24, 25, 26, 27) - 620 грамм",
        price: "595 BYN",
        flex: [],
      },
    ],
    pics: [G1D, G2D],
  },
];

function App() {
  const [form] = Form.useForm();
  const [orderForm] = Form.useForm();

  const [title, setTitle] = useState("");
  const [isOpen, setOpen] = useState(false);
  const [selectedModel, setSelectedModel] = useState<string>();
  const [flex, setFlex] = useState<number[]>([]);
  const screens = Grid.useBreakpoint();
  const isMobile = !screens.md;
  const [picIdx, setPicIdx] = useState(0);

  const myRef = useRef<HTMLDivElement | null>(null);
  const mainRef = useRef<HTMLDivElement | null>(null);
  const formRef = useRef<HTMLDivElement | null>(null);

  const handleClick = () => {
    if (myRef.current) {
      myRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const goToForm = () => {
    if (formRef.current) {
      formRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const goHome = () => {
    if (mainRef.current) {
      mainRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const onClose = () => {
    setOpen(false);
    orderForm.resetFields();
    setSelectedModel(undefined);
  };

  const selection = sticks.find((e) => e.title === title);
  const selectedOption = selection?.options?.find((opt) => opt.model === selectedModel);
  const grabOptions = (selection?.grab ?? []).map((grab) => ({ value: grab.value, label: grab.label }));

  console.log(selectedOption);

  useEffect(() => {
    if (!isOpen) {
      return;
    }

    const defaultOption = selection?.options?.[0];
    if (!defaultOption) {
      setSelectedModel(undefined);
      orderForm.resetFields();
      return;
    }

    setSelectedModel(defaultOption.model);
    orderForm.setFieldsValue({
      model: defaultOption.model,
      height: defaultOption.size,
      price: defaultOption.price,
      grab: selection?.grab?.[0]?.value ?? "right",
    });
  }, [isOpen, orderForm, selection]);

  const handleModelChange = (model: string) => {
    setSelectedModel(model);
    const option = selection?.options?.find((opt) => opt.model === model);
    setFlex(option?.flex ?? []);
    orderForm.setFieldsValue({
      height: option?.size,
      price: option?.price,
    });
  };

  const price = Form.useWatch("price", orderForm);

  const isGoalie = selection?.title === "Вратарские";

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: PRIMARY,
          borderRadius: 10,
          fontFamily: '"Montserrat", sans-serif',
        },
        components: {
          Input: {
            colorBgContainerDisabled: "#f2f3f786",
            colorTextDisabled: "#6c7283",
            colorBorder: "#eaedf5",
            controlHeight: isMobile ? 44 : 50,
            fontSize: isMobile ? 16 : 18,
          },
          Select: {
            colorBgContainerDisabled: "#f2f3f786",
            colorTextDisabled: "#6c7283",
            colorBorder: "#eaedf5",
            controlHeight: isMobile ? 44 : 50,
            fontSize: isMobile ? 16 : 18,
          },
          Form: {
            labelColor: "white",
            labelFontSize: isMobile ? 18 : 22,
          },
          Button: {
            fontWeight: 600,
            primaryShadow: `0 10px 26px -8px ${PRIMARY}88`,
          },
        },
      }}
    >
      <div className={styles.app}>
        <div ref={mainRef} />

        <div className={styles.menu}>
          <div className={styles.menuContent}>
            <div className={styles.logo} onClick={goHome} />
            <div className={styles.items}>
              <span className={styles.iconBtn} onClick={() => window.open("https://t.me/castorhockey", "_blank")}>
                <Telegram cursor={"pointer"} color="white" size={18} />
              </span>
              <span className={styles.iconBtn} onClick={() => window.open("https://www.instagram.com/castorhockey/", "_blank")}>
                <Instagram cursor={"pointer"} color="white" size={18} />
              </span>
              <span className={styles.iconBtn} onClick={() => window.open("https://www.tiktok.com/@castor_hockey", "_blank")}>
                <Tiktok cursor={"pointer"} color="white" size={18} />
              </span>
            </div>
          </div>
        </div>
        <div className={styles.head}>
          <div className={styles.logo} />
          <div className={styles.logoText} />
          <Button size="large" type="primary" onClick={goToForm}>
            Оформить заказ <ArrowRight size={18} />
          </Button>
          <div className={styles.heroBadges}>
            <div className={styles.badge}>
              <Lightning size={16} />
              <span>Гиперкарбон Toray</span>
            </div>
            <div className={styles.badge}>
              <Award size={16} />
              <span>18K плетение</span>
            </div>
            <div className={styles.badge}>
              <ShieldCheck size={16} />
              <span>Гарантия качества</span>
            </div>
          </div>
        </div>
        <div className={styles.body}>
          <div className={styles.content}>
            <div className={styles.label}>
              <h3>{`Клюшки для побед на льду \n выбирайте лучшее!`}</h3>
              <p>{`Серия разработана с использованием гиперкарбона Toray и высококачественного \n 18-каратного поверхностью плетения`}</p>
            </div>
            <div className={styles.cards} ref={myRef}>
              {sticks.map((e) => (
                <div
                  className={styles.card}
                  key={e.title}
                  onClick={() => {
                    setPicIdx(Math.floor(Math.random() * 2));
                    setTitle(e.title);
                    setOpen(true);
                    setFlex(e.options[0].flex);
                    form.resetFields();
                  }}
                >
                  <div>
                    <h2>{e.title}</h2>
                    <div className={styles.figs}>
                      {e.options?.map((option) => (
                        <div key={option.model} className={styles.option}>
                          <div>{`${option.model} - ${option.price}`}</div>
                          <div className={styles.size}>{option.size}</div>
                        </div>
                      ))}
                      <div>Хват: Левый / Правый</div>
                      <Button size="large" type="primary" onClick={handleClick} icon={<ArrowRight size={16} />} iconPosition="end">
                        Купить
                      </Button>
                    </div>
                  </div>
                  <div className={styles.sticks}>
                    {e.pics.map((e) => (
                      <img src={e} alt={e} />
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className={styles.footer} id="form" ref={formRef}>
            <h1>Связаться с нами</h1>

            <Form className={styles.form} form={form} layout="vertical">
              <Form.Item label="Ваш e-mail">
                <Input placeholder="Ваше имя" />
              </Form.Item>
              <Form.Item label="Ваш телефон">
                <Input placeholder="Телефон" />
              </Form.Item>
              <Form.Item label="Ваше Имя">
                <Input placeholder="Имя" />
              </Form.Item>
              <Form.Item label="Напишите вопрос или укажите модель клюшки">
                <Input.TextArea />
              </Form.Item>
              <Button
                type="primary"
                size="large"
                block
                style={{ fontSize: 20, height: 50 }}
                icon={<ArrowRight size={18} />}
                iconPosition="end"
              >
                Отправить
              </Button>
            </Form>
          </div>
          <div className={styles.delivery}>
            <div className={styles.deliveryIcon}>
              <Truck size={26} />
            </div>
            <h1>Информация о доставке</h1>
            <p>{`Мы находимся в Минске. Вы можете самостоятельно забрать покупку из точки самовывоза или заказать доставку курьером по Минске и Минской области. Также доступна доставка почтой по всей Беларуси.`}</p>
          </div>
          <div className={styles.delivery}>
            <div className={styles.deliveryIcon}>
              <CreditCard2Front size={26} />
            </div>
            <h1>Для оплаты в ЕРИП</h1>
            <p>В перечне услуг ЕРИП перейдите в раздел:</p>
            <p>
              <b>Сервис E-POS → E-POS - оплата товаров и услуг</b>
            </p>
            <p>
              Можно осуществить поиск по коду услуги: <b>4440631</b>
            </p>
            <p>
              В поле «Номер лицевого счета» введите <b>36630-1-001</b> и нажмите «Продолжить»
            </p>
            <p>Укажите сумму для оплаты</p>
          </div>
          <div className={styles.footerLine}>
            <p>© Castor, 2026</p>
            <p>{"info@castor.by / +375 29 2551 718"}</p>
          </div>
        </div>
      </div>
      <Modal
        title={<div style={{ fontSize: 24 }}>{title}</div>}
        open={isOpen}
        onCancel={onClose}
        width={isMobile ? "calc(100vw - 16px)" : 1200}
        footer={null}
        centered
        styles={{
          header: { display: "none" },
          body: { padding: 0 },
          content: { padding: 0, borderRadius: 18, border: "1px solid rgba(47, 230, 213, 0.22)" },
        }}
      >
        <ConfigProvider
          theme={{
            components: {
              Input: {
                colorBgContainerDisabled: "white",
                colorTextDisabled: "black",
                colorBorder: "rgba(0, 0, 0, 0.4)",
                lineWidth: 0,
                controlHeight: isMobile ? 44 : 50,
                fontSize: isMobile ? 16 : 18,
              },
              Select: {
                colorBgContainerDisabled: "black",
                colorTextDisabled: "black",
                colorBorder: "rgba(0, 0, 0, 0.4)",
                lineWidth: 0,
                controlHeight: isMobile ? 44 : 50,
                fontSize: isMobile ? 16 : 18,
              },
              Form: {
                labelColor: "white",
                labelFontSize: isMobile ? 18 : 22,
                itemMarginBottom: 12,
              },
              Segmented: {
                itemSelectedBg: PRIMARY,
                itemActiveBg: PRIMARY_DARK,
                itemColor: "rgba(255, 255, 255, 0.75)",
                itemSelectedColor: INK,
                trackBg: "transparent",
              },
            },
          }}
        >
          <div className={styles.order}>
            <div className={styles.stickPreview} style={{ backgroundImage: `url(${selection?.pics[picIdx]})` }} />
            <div className={styles.form}>
              <Form
                form={orderForm}
                labelAlign="left"
                layout={isMobile ? "vertical" : "horizontal"}
                labelCol={isMobile ? undefined : { span: 10 }}
              >
                <div className={styles.headTitle}>
                  <h2>{`${price}`}</h2>
                  <XCircle size={30} cursor={"pointer"} onClick={onClose} />
                </div>
                <Form.Item name={"model"} label="Модель клюшки" rules={[{ required: true, message: "Выберите модель клюшки" }]}>
                  <Select
                    placeholder="Выберите модель товара"
                    options={
                      selection?.options?.map((option) => ({
                        value: option.model,
                        label: `${option.model} — ${option.price}`,
                      })) ?? []
                    }
                    onChange={handleModelChange}
                  />
                </Form.Item>
                <Form.Item name={"height"} label="Длина клюшки">
                  <Input disabled />
                </Form.Item>
                <Form.Item name={"price"} label="Стоимость" hidden>
                  <Input disabled />
                </Form.Item>
                <Form.Item name={"strength"} label="Жесткость" hidden={isGoalie}>
                  <Segmented block size="large" placeholder="Выберите жесткость" options={flex?.map((e) => ({ value: e, label: e }))} />
                </Form.Item>
                <Form.Item name={"grab"} label="Хват">
                  <Segmented block size="large" options={grabOptions} placeholder="Выберите хват" />
                </Form.Item>
                <Form.Item name={"email"} label="Ваш e-mail" rules={[{ required: true, message: "", type: "email" }]}>
                  <Input placeholder="Ваш e-mail" />
                </Form.Item>
                <Form.Item name={"phone"} label="Ваш телефон">
                  <Input placeholder="Телефон" />
                </Form.Item>
                <Form.Item name={"name"} label="Ваше Имя">
                  <Input placeholder="Имя" />
                </Form.Item>
                <Button
                  type="primary"
                  size="large"
                  icon={<ArrowRight size={18} />}
                  iconPosition="end"
                  style={{
                    fontSize: isMobile ? 18 : 22,
                    width: isMobile ? "100%" : "fit-content",
                    height: "fit-content",
                    padding: isMobile ? "8px 16px" : "8px 32px",
                    fontWeight: 600,
                  }}
                >
                  Оформить заказ
                </Button>
              </Form>
            </div>
          </div>
        </ConfigProvider>
      </Modal>
    </ConfigProvider>
  );
}

export default App;
